import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import AndroidInstall from "../../integrate/_snippets/install-android.mdx";
export const EnableSessionReplayDark = "https://res.cloudinary.com/dmukukwp6/image/upload/posthog.com/contents/images/docs/session-replay/enable-session-replay-in-project-settings-dark-mode.png";
export const EnableSessionReplayLight = "https://res.cloudinary.com/dmukukwp6/image/upload/posthog.com/contents/images/docs/session-replay/enable-session-replay-in-project-settings-light-mode.png";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  EnableSessionReplayDark,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "step-one-add-posthog-to-your-app"
    }}>{`Step one: Add PostHog to your app`}</h2>


    <AndroidInstall mdxType="AndroidInstall" />
    <blockquote>
      <p parentName="blockquote">{`Session replay requires PostHog Android SDK version >= `}<a parentName="p" {...{
          "href": "https://github.com/PostHog/posthog-android/releases"
        }}>{`3.4.0`}</a>{`, and it's recommended to always use `}<a parentName="p" {...{
          "href": "/docs/sdk-doctor"
        }}>{`the latest version`}</a>{`.`}</p>
    </blockquote>
    <h2 {...{
      "id": "step-two-enable-session-recordings-in-your-project-settings"
    }}>{`Step two: Enable session recordings in your project settings`}</h2>
    <p>{`Enable session recordings in your PostHog `}<a parentName="p" {...{
        "href": "https://app.posthog.com/project/settings"
      }}>{`Project Settings`}</a>{`.`}</p>
    <ProductScreenshot imageLight={EnableSessionReplayLight} imageDark={EnableSessionReplayDark} alt="Enable session recordings in your PostHog'" classes="rounded" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "step-three-configure-replay-settings"
    }}>{`Step three: Configure replay settings`}</h2>
    <p>{`Add `}<inlineCode parentName="p">{`sessionReplay = true`}</inlineCode>{` to your PostHog configuration alongside any of your other configuration options:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-android_kotlin"
      }}>{`val config = PostHogAndroidConfig(apiKey = "<ph_project_api_key>").apply {
    // Enable session recording. Requires enabling in your project settings as well.
    // Default is false.
    sessionReplay = true

    // Whether text and text input fields are masked. Default is true.
    // Password inputs are always masked regardless
    sessionReplayConfig.maskAllTextInputs = true

    // Whether images are masked. Default is true.
    sessionReplayConfig.maskAllImages = true

    // Capture logs automatically. Default is true.
    sessionReplayConfig.captureLogcat = true

    // Whether replays are created using high quality screenshots. Default is false.
    // If disabled, replays are created using wireframes instead.
    // The screenshot may contain sensitive information, so use with caution
    sessionReplayConfig.screenshot = false

    // Throttle delay used to reduce the number of snapshots captured and reduce performance impact. Default is 1000ms
    // Ps: it was 500ms (0.5s) by default until version 3.8.2
    // Available from version 3.10.0 (Before it was called debouncerDelayMs)
    sessionReplayConfig.throttleDelayMs = 1000
}
`}</code></pre>
    <h3 {...{
      "id": "limitations"
    }}>{`Limitations`}</h3>
    <ul>
      <li parentName="ul">{`Requires Android API >= 26.`}</li>
      <li parentName="ul">{`Jetpack Compose is only supported if `}<inlineCode parentName="li">{`screenshot`}</inlineCode>{` is enabled.`}</li>
      <li parentName="ul">{`Custom views are partly supported, and only fully supported if `}<inlineCode parentName="li">{`screenshot`}</inlineCode>{`  is enabled.`}</li>
      <li parentName="ul">{`WebView is only supported if `}<inlineCode parentName="li">{`screenshot`}</inlineCode>{` is enabled. A placeholder will be shown as a fallback.`}</li>
      <li parentName="ul">{`Keyboard is not supported. A placeholder will be shown.`}</li>
    </ul>
    <h2 {...{
      "id": "troubleshooting"
    }}>{`Troubleshooting`}</h2>
    <ul>
      <li parentName="ul">{`Update your SDK.`}</li>
      <li parentName="ul">{`If you have enabled session replay using feature flags, the flags are evaluated on the device once the PostHog SDK starts as early as possible. The SDK might be using the cached flags from the previous SDK start. If you have changed the flag or its condition, kill and reopen the app to force a new SDK start at least once.`}
        <ul parentName="li">
          <li parentName="ul">{`This will also happen in production, and you might experience some delay for the new flag/conditions to take effect on your users. We're tracking this bug `}<a parentName="li" {...{
              "href": "https://github.com/PostHog/posthog-ios/issues/263"
            }}>{`here`}</a>{`.`}</li>
          <li parentName="ul">{`Session replay feature flag evaluation does not capture `}<inlineCode parentName="li">{`$feature_flag_called`}</inlineCode>{` events, so the `}<inlineCode parentName="li">{`Usage`}</inlineCode>{` tab on the feature flag page won't show anything. We're tracking this feature request `}<a parentName="li" {...{
              "href": "https://github.com/PostHog/posthog-android/issues/250"
            }}>{`here`}</a>{`.`}</li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      